import { useState, useRef, useEffect } from 'react'

import SortIcon from 'assets/icons/SortIcon.svg'
interface Props {
  value: string
  onChange: (v: string) => void
}

export const BrandSort = ({ value, onChange }: Props) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const options = [
    { label: 'Most recent', value: 'Recent' },
    { label: 'By brand', value: 'brand' },
    { label: 'By category', value: 'category' },
  ]

  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="relative" ref={ref}>
      {/* SORT ICON */}
      <img
        src={SortIcon}
        alt="sort"
        className="cursor-pointer"
        width="40"
        height="40"
        onClick={() => setOpen(prev => !prev)}
      />

      {/* DROPDOWN */}
      {open && (
        <div className="absolute right-0 mt-2 option-wrapper">
          {options.map(option => (
            <div
              key={option.value}
              className={`option-wrapper-item cursor-pointer  ${value === option.value ? 'subtitle-s' : 'body-s'}`}
              onClick={() => {
                onChange(option.value)
                setOpen(false)
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
